import { sessionDetails } from '../../../models/GSessions';
import {EventFullInfo} from '../../../models/event';
import React from 'react';
import * as validationStrings from './GSessionEditModalConstants';
import DateTimePicker from 'react-datetime-picker';

interface GSessionEditModalProps {
    requestClose: () => void,
    requestView: () => void,
    session: sessionDetails,
    event: EventFullInfo
    playerNames: string[],
    user_id: number,
    user_name: string,
    onSessionUpdate: (sesh: sessionDetails) => Promise<boolean>,
    onSessionDelete: () => void
}

const GSessionEditModal = (props: GSessionEditModalProps) => {

    const occupiedSlots = props.playerNames.length;
    const totalSlots = props.session.slots + occupiedSlots;
    const isOwnerRSVPed = props.playerNames.includes(props.user_name);

    const [startTime, setStartTime] = React.useState<Date>(props.session.start);
    const [stopTime, setStopTime] = React.useState<Date>(props.session.end);
    const [sessionName, setSessionName] = React.useState<string>(props.session.name);
    const [bggPage, setBggPage] = React.useState<string>(props.session.bgg_title_link || "");
    const [sessionDesc, setSessionDesc] = React.useState<string>(props.session.info);
    const [tableNum, setTableNum] = React.useState<string>(props.session.table.toString());
    const [slotMax, setSlotMax] = React.useState<string>(totalSlots.toString());
    const [autoRSVP, setAutoRSVP] = React.useState<boolean>(props.session.owner_player);
    const [statusMsg, setStatusMsg] = React.useState<string>("");
    const [falureMessage, setFailureMessage] = React.useState<boolean>(false);
    const [deleteConfirmation, setDeleteConfirmation] = React.useState<boolean>(false);
    //const [submitEnable, setSubmitEnable] = React.useState<boolean>(true);
    //const [deleteRequested, setDeleteRequested] = React.useState<boolean>(false);

    React.useEffect(() => {
        const startTimeInPast = startTime < new Date();
        const startOutOfBounds = startTime < props.event.start_DateTime || startTime > props.event.end_DateTime
        const endTimeInPast = stopTime < new Date();
        const endOutOfBounds = stopTime < props.event.start_DateTime || stopTime > props.event.end_DateTime
        const endBeforeBegin = startTime > stopTime;
        const nameIsNull = sessionName.trim() === "";
        const tableOutOfBounds = parseInt(tableNum,10) < props.event.lowest_Table_Number || parseInt(tableNum,10) > props.event.highest_Table_Number
        const slotsIsBad = slotMax.trim() === "0" || slotMax.trim() === "" || isNaN(+slotMax);
        const tooManySlots = +slotMax > props.event.slots;

        const message = [
            (startTimeInPast ? validationStrings.START_TIME_IN_PAST : []),
            (startOutOfBounds ? validationStrings.START_OUT_OF_BOUNDS : []),
            (endTimeInPast ? validationStrings.END_TIME_IN_PAST : []),
            (endOutOfBounds ? validationStrings.END_OUT_OF_BOUNDS : []),
            (endBeforeBegin ? validationStrings.END_BEFORE_BEGIN : []),
            (nameIsNull ? validationStrings.NAME_IS_NULL : []),
            (tableOutOfBounds ? validationStrings.TABLE_OUT_OF_BOUNDS : []),
            (slotsIsBad ? validationStrings.SLOTS_IS_BAD : []),
            (tooManySlots ? validationStrings.TOO_MANY_SLOTS : [])
        ].join('\n');

        const trimmedMessage = message.trim()

        setStatusMsg(trimmedMessage.length === 0 ? "" : message);


    },[startTime, stopTime, sessionName, tableNum, slotMax]);

    const requestUpdate = () => {

        setFailureMessage(false);

        const outputSesh : sessionDetails = {
            start: startTime,
            end: stopTime,
            name: sessionName,
            bgg_title_link: bggPage,
            info: sessionDesc,
            room: "",
            table: tableNum,
            slots: parseInt(slotMax),
            owner_player: autoRSVP,
            owner: props.user_name,
            id: props.session.id,
            evt: props.event.id
        }

        props.onSessionUpdate(outputSesh).then((res) => {
            if (res === false)
            {
                setFailureMessage(true);
            }
        })
    }

    return (
    <div>
        <h3>Edit Session</h3>
        <hr />
        <div className="modalContent">
            <p>Session Name</p>
            <input name="SessionName"
                className="largeInput"
                placeholder="Game Name"
                value={sessionName}
                onChange={(val) => setSessionName(val.target.value)} />
            <p>BGG Page</p>
            <textarea name="BGGPage"
                className="largeTextField"
                value={bggPage}
                placeholder="https://www.boardgamegeek.com/....."
                onChange={(e) => setBggPage(e.target.value)} />
            <p>Description</p>
            <textarea name="Description"
                className="largeTextField"
                placeholder="What people need to know"
                value={sessionDesc}
                onChange={(e) => setSessionDesc(e.target.value)} />
            <p>Table</p>
            <input name="Table"
                className="smallInput"
                value={tableNum}
                onChange={(e) =>{setTableNum(e.target.value)}} />
            <p>Number of Slots</p>
            <input type="number"
                    min="2"
                    max={props.event.slots}
                    name="Slots"
                    className="smallInput"
                    placeholder="Maximum number of participants"
                    value={slotMax}
                    onChange={(e) => setSlotMax(e.target.value)} />
            <p>Start Time</p>
            <DateTimePicker name="StartTime"
                value={startTime as Date}
                onChange={(val) => setStartTime(val as Date)} />
            <p>Stop Time</p>
            <DateTimePicker name="StopTime"
                value={stopTime as Date}
                onChange={(val) => setStopTime(val as Date)} />
            <br></br>
            <br></br>
            {!isOwnerRSVPed && <label>
                <input type="checkbox" name="AutoRSVP"
                    checked={autoRSVP}
                    onChange={() => setAutoRSVP(!autoRSVP)} /> Also sign yourself up for this session
            </label>}
            <br></br>
            <br></br>
            {!deleteConfirmation && <button className="buttonSecond" onClick={() => setDeleteConfirmation(true)}>Delete Session</button>}
            <br></br>
            <br></br>
        </div>
        <div className="modalButtons">
            {statusMsg !== "" ?  <p>{statusMsg}</p> : <span></span>}
            {deleteConfirmation && <div className="deleteMode">
                <b>Are you sure you want to delete this session?</b>
                <button className="buttonSecond" onClick={()=>props.onSessionDelete()}>Yes</button>
                <button className="buttonPrimary" onClick={()=>setDeleteConfirmation(false)}>No</button>
            </div>}
            {!deleteConfirmation && <div className="defaultMode">
                {statusMsg === "" ? <button className="buttonPrimary" onClick={() => requestUpdate()}>Save</button> : <span></span>}
                <button className="buttonPrimary" onClick={() => props.requestClose()}>Back to Calendar</button>
                <button className="buttonPrimary" onClick={() => props.requestView()}>Cancel</button>
            </div>}
        </div>
    </div>)
}

export default GSessionEditModal;